module.exports = __webpack_public_path__ + "img/5.a363de9f.png";